import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MarvJsonService {
    
    static Parse(s: string): any{
        return JSON.parse(s, (key, value) => {
            if(typeof value === 'object' && value !== null) {
                if (value.dataType === 'Map') {
                    return new Map(value.value);
                }
                else if (value.dataType === 'Date') {
                    return new Date(value.value);
                }
            }
            return value;
        });
    }
    
    static Stringify(o: any): string{
        return JSON.stringify(o, (key, value) => {
            if(value instanceof Map) {
                return {
                    dataType: 'Map',
                    value: Array.from(value.entries()),
                };
            } 
            else if(value instanceof Date){
                return {
                    dataType: 'Date',
                    value: value,
                };
            }            
            else if(value instanceof Subject){
                return undefined;
            }            
            else {
                return value;
            }
        });
    }
    
}
